export class Page {
    size: number;
    totalElements: number;
    totalPages: number;
    pageNumber: number;
    sortProp: string;
    sortOrder: string;
    filter: any[];
    state: number;
    motive: number;
    types: number;
    typeAcre?: number;
    filterView?: number;
    approved?: number;

    constructor() {
        this.size = 0;
        this.totalElements = 0;
        this.totalPages = 0;
        this.pageNumber = 0;
        this.sortProp = '';
        this.sortOrder = '';
        this.filter = [];
        this.state = 1;
        this.motive = 1;
       /*  this.types = 1;
        this.filterView = 1; */
    }
}

export class LiquidationPage extends Page {
  reassigned: number;
}

export class EmbargoReassignationPage extends Page {
  searchTerm: string;
}

export class DateFilterPage extends Page {
  date_from?: string;
  date_at?: string;
}
